import React, { useEffect, useState, useContext } from 'react';
import { consts, icons, lang } from '../services/_consts';
import CvMakerContext from '../services/app-context';
import Helper from '../services/Helper'

export const SaveDialog = ({ title, saveCv, saveToServer, ocClose, onAfterLogin }) => {

    const [userName, setUserName] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [saving, setSaving] = useState(false);
    const [cvtitle, setCvTitle] = useState(title);
    const context = useContext(CvMakerContext);

    const login = async () => {
        setLoading(true);
        const data = await Helper.callApiAsJson({ url: 'authenticate/Login', type: 'post', data: { userName, password } })

        setLoading(false);
        if (data) {
            context.setCurrentUser(data);
            localStorage.setItem("token", data.token);
            if (onAfterLogin)
                onAfterLogin();
        }
        else {
            alert("")
        }
    }


    return (
        <div className="modal fade show" tabIndex="-1" role="dialog" style={{ display: "block", backdropFilter: 'blur(5px)', background: '#bdbdbd96' }}>
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header headcolor">
                        <h5 className="modal-title" > </h5>
                        <button onClick={ocClose} type="button" className="btn-close" ></button>
                    </div>
                    <div className="modal-body">
                        {
                            !context.getCurrentUser() ?

                                <div className="mb-4">
                                    <div className="mb-3">
                                        <label htmlFor="username" className="form-label">Email</label>
                                        <input value={userName} onChange={e => setUserName(e.target.value)} type="email" className="form-control" id="username" placeholder="name@example.com" />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="pass" className="form-label">Password</label>
                                        <input value={password} onChange={e => setPassword(e.target.value)} type="password" className="form-control" id="pass" placeholder="" />
                                    </div>
                                    <div className="mb-3">
                                        {loading ? <div className="spinner-border" role="status"></div> :
                                            <button onClick={login} className="btn btn-outline-dark btn-block me-1 bg-white2">{context.lang.login} <i className={icons.signIn}></i></button>
                                        }
                                    </div>
                                </div>
                                :
                                <div className="row g-3">
                                    <div className="col-auto">
                                        <label htmlFor="title" >Title</label>
                                        <input value={cvtitle} onChange={e => setCvTitle(e.target.value)} className="form-control" id="title" />
                                    </div>
                                    <div className="col-auto pt-4">
                                        {saving ? <div className="spinner-border" role="status"></div> :
                                            <button onClick={() => {
                                                setSaving(true);
                                                saveToServer(cvtitle);
                                                //setSaving(false);
                                            }} className="btn btn-outline-dark bg-white2 mb-3">
                                                {context.lang.save} <i className={icons.save}></i>
                                            </button>
                                        }
                                    </div>
                                </div>
                        }
                        <hr />
                        or <button onClick={saveCv} className="btn btn-outline-dark bg-white2 my-3">{context.lang.saveToPc} <i className={icons.download}></i></button>

                    </div>
                </div>
            </div>
        </div>
    );

}